import { FC, PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

type BaseCampaignStepProps = PropsWithChildren & {
  className?: string;
};

export const BaseCampaignStep: FC<BaseCampaignStepProps> = ({ children, className }) => {
  return <div className={twMerge('grow overflow-y-auto p-12', className)}>{children}</div>;
};
